// pluralise.js
// "1 row", "2 rows", "1,204 rows": a count with its noun, singular only for
// exactly one. Every result footer and summary that names a count uses this,
// so no surface can print "1 rows".
export const countNoun = (count, singular, plural = `${singular}s`) => {
  const number = Number(count) || 0;
  return `${number.toLocaleString()} ${number === 1 ? singular : plural}`;
};
